export default __webpack_public_path__ + "static/media/CarDetailingProtection.649081fe.jpg";